module.exports = __webpack_public_path__ + "img/book.3704ddad.svg";